import apiClient from "./client";
import type {
  CommunityPost,
  CommunityReply,
  LikeToggleResult,
  Paginated,
} from "@/types";

/**
 * Community API (صحبت کنیم).
 * Backend: /community/posts, replies, likes
 */

export async function listCommunityPosts({
  page = 1,
  size = 20,
}: { page?: number; size?: number } = {}): Promise<Paginated<CommunityPost>> {
  const { data } = await apiClient.get<Paginated<CommunityPost>>(
    "/community/posts",
    { params: { page, size } }
  );
  return data;
}

export async function createCommunityPost(
  body: string
): Promise<CommunityPost> {
  const { data } = await apiClient.post<CommunityPost>("/community/posts", {
    body,
  });
  return data;
}

export async function createCommunityReply(
  postId: number,
  body: string
): Promise<CommunityReply> {
  const { data } = await apiClient.post<CommunityReply>(
    `/community/posts/${postId}/replies`,
    { body }
  );
  return data;
}

export async function togglePostLike(
  postId: number
): Promise<LikeToggleResult> {
  const { data } = await apiClient.post<LikeToggleResult>(
    `/community/posts/${postId}/like`
  );
  return data;
}

export async function toggleReplyLike(
  replyId: number
): Promise<LikeToggleResult> {
  const { data } = await apiClient.post<LikeToggleResult>(
    `/community/replies/${replyId}/like`
  );
  return data;
}
